var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter",attrs:{"id":"js-counter"}},[_c('div',{staticClass:"counter_monitor"},[_vm._v(_vm._s(_vm.counter)+" 年")])])
}
var staticRenderFns = []

export { render, staticRenderFns }